"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var icon_picker_1 = require("../../controls/icon-picker");
wp.customize.controlConstructor['epsilon-icon-picker'] = wp.customize.Control.extend({
    ready: function () {
        var control = this;
        new icon_picker_1.EpsilonIconPicker(control, false);
        control.container.on('change', 'input.epsilon-icon-picker', function (event) {
            control.setting.set(jQuery(event.target).val());
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/controls/icon-picker.ts
// module id = 15
// module chunks = 0